import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reports: {
		id: 'spa-apps-software-reports-cycle-time-report.reports',
		defaultMessage: 'Reports',
		description: 'Title of a section',
	},
	browserTitle: {
		id: 'spa-apps-software-reports-cycle-time-report.browser-title',
		defaultMessage: 'Cycle time',
		description:
			'The title of a report that shows how long it takes a team to implement and deliver issues',
	},
});
